const intervalId = setInterval(function() {
  if (document.querySelectorAll('#ai-size-popup').length > 0) {
    clearInterval(intervalId);
 
    const popupContainer = document.querySelector('#ai-size-popup');
    const sizeBtnContainer = document.querySelector('.ai-size-button-container');
 
    const sizeGuideBtn = document.createElement('div');
    sizeGuideBtn.className = 'btn-size-guide';
    sizeGuideBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 203.544 203.544" version="1.1" id="Capa_1"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 203.544 203.544"
        xml:space="preserve" fill="#000000" transform="rotate(90)">
        <g id="SVGRepo_bgCarrier" stroke-width="0" />
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
        <g id="SVGRepo_iconCarrier">
          <g>
            <g>
              <path class="icon-path" style="fill:#010002;"
                d="M41.717,0L0.002,41.722l161.821,161.821l41.719-41.719L41.717,0z M41.717,8.049l153.78,153.776 l-33.673,33.673l-4.452-4.459l23.245-23.255c0.92-0.913,0.92-2.391,0-3.303c-0.913-0.913-2.391-0.923-3.303,0l-23.255,23.245 l-7.233-7.226l14.974-14.977c0.916-0.913,0.916-2.394,0-3.307c-0.92-0.923-2.387-0.923-3.307,0l-14.977,14.97l-5.973-5.98 l14.974-14.967c0.905-0.913,0.905-2.405,0-3.314c-0.923-0.913-2.405-0.913-3.321,0l-14.967,14.967l-5.73-5.726l14.97-14.97 c0.916-0.913,0.916-2.391,0-3.303c-0.913-0.923-2.391-0.923-3.31,0l-14.974,14.97l-6.471-6.488l23.252-23.245 c0.913-0.923,0.913-2.405,0-3.314c-0.923-0.913-2.398-0.913-3.314,0l-23.248,23.255l-4.477-4.481l15.729-15.718 c0.913-0.913,0.913-2.391-0.011-3.314c-0.909-0.913-2.387-0.913-3.303,0l-15.725,15.729l-5.977-5.98l15.722-15.729 c0.916-0.913,0.916-2.391,0-3.303c-0.913-0.923-2.391-0.923-3.303,0l-15.729,15.718l-5.726-5.726l15.722-15.718 c0.916-0.923,0.916-2.401,0-3.314c-0.916-0.913-2.398-0.913-3.31,0l-15.725,15.718l-6.546-6.546L106,93.147 c0.913-0.913,0.905-2.391-0.011-3.303c-0.913-0.913-2.394-0.913-3.303-0.011l-23.255,23.259l-7.226-7.229l14.967-14.977 c0.916-0.913,0.916-2.391-0.011-3.303c-0.902-0.923-2.384-0.913-3.296,0l-14.974,14.967l-5.984-5.98l14.977-14.967 c0.905-0.913,0.905-2.401,0-3.303c-0.916-0.923-2.394-0.923-3.307-0.011L59.611,93.265l-5.73-5.737l14.963-14.967 c0.92-0.913,0.913-2.391,0-3.314c-0.905-0.909-2.387-0.909-3.303,0L50.575,84.225l-6.481-6.474l23.255-23.259 c0.905-0.913,0.905-2.401-0.004-3.314c-0.916-0.913-2.398-0.913-3.314,0L40.786,74.433l-4.47-4.477l15.718-15.718 c0.913-0.913,0.913-2.391,0-3.303c-0.916-0.923-2.394-0.923-3.314,0L32.999,66.653l-5.973-5.977l15.718-15.718 c0.916-0.923,0.916-2.401,0-3.314c-0.913-0.913-2.391-0.913-3.31,0L23.722,57.362l-5.737-5.726l15.722-15.729 c0.916-0.902,0.916-2.384,0-3.303c-0.916-0.913-2.394-0.913-3.307,0L14.672,48.332l-6.617-6.628L41.717,8.049z" />
            </g>
          </g>
        </g>
      </svg> <span>Size Guide</span>`;
 
    const observer = new MutationObserver((mutations, obs) => {
      const sizeBtn = document.querySelector(".ai-size-button");
      if (sizeBtn && sizeBtn.hasAttribute("style")) {
        sizeGuideBtn.setAttribute('style', sizeBtn.getAttribute("style"));
        obs.disconnect();
      }
    });
 
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style"]
    });
 
    if (sizeBtnContainer) {
      sizeBtnContainer.prepend(sizeGuideBtn);
    }
 
    sizeGuideBtn.addEventListener('click', () => {
      popupContainer.querySelector('.size-tab-main button.active').click();
    });
 
    const aiSizeButtonCount = document.querySelectorAll('.ai-size-button')?.length || 0;
    const aiSizeGuideButtonCount = document.querySelectorAll('.ai-size-guide-button')?.length || 0;
 
    const sizeTab = document.createElement('div');
    sizeTab.className = 'size-tab-main';
    sizeTab.innerHTML = `
      <button class="btn-rec active">Size Recommendation</button>
      <button class="btn-chart">Size Chart</button>
      <span class="close-popup"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="15" fill="#683894"></circle><path d="M20.7564 9.25199C20.6792 9.17464 20.5875 9.11328 20.4865 9.07141C20.3856 9.02954 20.2774 9.00799 20.1681 9.00799C20.0589 9.00799 19.9507 9.02954 19.8497 9.07141C19.7488 9.11328 19.6571 9.17464 19.5799 9.25199L15.5 13.3236L11.4201 9.24364C11.3428 9.1664 11.2511 9.10513 11.1502 9.06332C11.0493 9.02152 10.9411 9 10.8319 9C10.7226 9 10.6144 9.02152 10.5135 9.06332C10.4126 9.10513 10.3209 9.1664 10.2436 9.24364C10.1664 9.32089 10.1051 9.41259 10.0633 9.51352C10.0215 9.61444 10 9.72262 10 9.83186C10 9.9411 10.0215 10.0493 10.0633 10.1502C10.1051 10.2511 10.1664 10.3428 10.2436 10.4201L14.3236 14.5L10.2436 18.5799C10.1664 18.6572 10.1051 18.7489 10.0633 18.8498C10.0215 18.9507 10 19.0589 10 19.1681C10 19.2774 10.0215 19.3856 10.0633 19.4865C10.1051 19.5874 10.1664 19.6791 10.2436 19.7564C10.3209 19.8336 10.4126 19.8949 10.5135 19.9367C10.6144 19.9785 10.7226 20 10.8319 20C10.9411 20 11.0493 19.9785 11.1502 19.9367C11.2511 19.8949 11.3428 19.8336 11.4201 19.7564L15.5 15.6764L19.5799 19.7564C19.6572 19.8336 19.7489 19.8949 19.8498 19.9367C19.9507 19.9785 20.0589 20 20.1681 20C20.2774 20 20.3856 19.9785 20.4865 19.9367C20.5874 19.8949 20.6791 19.8336 20.7564 19.7564C20.8336 19.6791 20.8949 19.5874 20.9367 19.4865C20.9785 19.3856 21 19.2774 21 19.1681C21 19.0589 20.9785 18.9507 20.9367 18.8498C20.8949 18.7489 20.8336 18.6572 20.7564 18.5799L16.6764 14.5L20.7564 10.4201C21.0734 10.103 21.0734 9.56904 20.7564 9.25199Z" fill="white"></path></svg></span>
    `;
 
    popupContainer.prepend(sizeTab);
 
    const btnRec = sizeTab.querySelector('.btn-rec');
    const btnChart = sizeTab.querySelector('.btn-chart');
 
    if (aiSizeButtonCount === 0) btnRec.style.display = "none";
    if (aiSizeGuideButtonCount === 0) btnChart.style.display = "none";
 
    const setActive = (activeBtn) => {
      [btnRec, btnChart].forEach(btn => btn.classList.remove('active'));
      activeBtn.classList.add('active');
    };
 
    btnRec.addEventListener('click', () => {
      setActive(btnRec);
      document.querySelector('.ai-size-button')?.click();
    });
 
    btnChart.addEventListener('click', () => {
      setActive(btnChart);
      document.querySelector('.ai-size-guide-button')?.click();
    });
 
   
    popupContainer.querySelector('.close-popup').addEventListener('click', () => {
      if(popupContainer.querySelector('.ai-size-popup-content:not(.ai-size-hidden)')){
        popupContainer.querySelector('.ai-size-popup-content .ai-size-popup-header .close').click();
      }
      if(popupContainer.querySelector('.ai-size-guide:not(.ai-size-hidden)')){
        popupContainer.querySelector('.ai-size-guide .ai-size-guide-header-container .close').click();
      }
    });
  }
}, 1000);
 
setTimeout(() => {
  clearInterval(intervalId);
}, 20000);